import { defineElement, FC, onDidLoad, useElement } from '@atomify/hooks';
import { getUserWishlist, userStore } from '@store/user';

const HIGHLIGHTED_CLASS = 'header-wishlist-button--highlighted';

const HeaderWishlistButton: FC = ({ element }) => {
    const wishlistTotal = useElement<HTMLElement>('[js-hook-header-wishlist-button-total]');

    let wishlistLength: number = 0;

    onDidLoad(() => {
        handleWishlist();
        userStore.subscribe(handleWishlist, ['wishlist']);
    });

    function handleWishlist() {
        const wishlist = getUserWishlist();
        wishlistLength = wishlist?.length || 0;

        setHighlightedClass();
        setWishlistTotal();
    }

    function setHighlightedClass() {
        if (wishlistLength) {
            element.classList.add(HIGHLIGHTED_CLASS);
        } else {
            element.classList.remove(HIGHLIGHTED_CLASS);
        }
    }

    function setWishlistTotal() {
        if (!wishlistTotal.current) return;

        wishlistTotal.current.innerHTML = wishlistLength ? `${wishlistLength}` : '';
    }
};

defineElement('bpd-header-wishlist-button', HeaderWishlistButton);
